import { cn } from '@/lib/cn'

interface KeyValueProps {
  label: string
  value: React.ReactNode
  className?: string
  href?: string
}

export function KeyValue({ label, value, className, href }: KeyValueProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <p className="text-sm font-semibold">{label}</p>
      <p className="text-sm text-gray-500">{value}</p>
    </div>
  )
}
